import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { RegisterRoutingModule } from "./register.routing";
import { RegisterAccountTypeComponent } from "./pages/account-type/account-type.component";
import { DialogModalComponent } from "src/app/shared/components/dialog-modal/dialog-modal.component";
import { SharedModule } from "src/app/shared/shared.module";
import { InvitationRegistrationComponent } from "./components/invitation-registration/invitation-registration.component";
import { NgxLoadingModule } from 'ngx-loading';
import { DeeplinkComponent } from './components/deeplink/deeplink.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    RegisterRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    NgxLoadingModule
  ],
  declarations: [RegisterAccountTypeComponent, InvitationRegistrationComponent, DeeplinkComponent],
  providers: [],
  entryComponents: [DialogModalComponent],
})
export class RegisterModule {}
